import axiosClient from "../axiosInstance";
import { ClientGroupRequest } from "api/models/ClientGroup";

export const getClientGroups = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/client-groups`);

  return response.data;
};

export const updateClientGroup = async (
  id: number,
  data: ClientGroupRequest,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.put(`/client-groups/${id}`, data);

  return response.data;
};

export const createClientGroup = async (
  data: ClientGroupRequest,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(`/client-groups`, data);

  return response.data;
};

export const deleteClientGroup = async (id: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(`/client-groups/${id}`);

  return response.data;
};

export const getClientGroupsByClientId = async (
  clientId: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/client-groups/client/${clientId}`);

  return response.data;
};

export const addClientToClientGroup = async (
  clientGroupId: number,
  clientId: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.put(`/client-groups/${clientGroupId}/add`, {
    clientId,
  });

  return response.data;
};

export const removeClientFromClientGroup = async (
  clientGroupId: number,
  clientId: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.put(`/client-groups/${clientGroupId}/remove`, {
    clientId,
  });

  return response.data;
};
